import { NotificationManager } from 'react-notifications';

export function numberWithCommas(x) {
	if(x){
    	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}else if(x === 0) {
		return 0;
	}else {
		return 'N/A';
	}
}

export function reloadPage() {
	location.reload();
}

export function checkProfilePic(data) {

	if(data.img) return data.img

	if(data.yt_img) return data.yt_img

	if(data.ig_img) return data.ig_img

}

export function encodeUrl(url) {
	url = encodeURI(url)
	url = url.replace(/#/g, '%23')

	return url
}

export function checkSexOption(value) {
	if (value && value.length !== 0) {
		return value.join()
	}
	return '0,1,2'
}

export function checkMylistStatusCode(code) {
	switch (code) {
		case '1000':
		break;
		case '1002':
			NotificationManager.success('更新成功', '成功', 5000)
		break;
		default:
			NotificationManager.warning('系統維修中', '維修中', 5000)
		break;
	}
}



// WEBPACK FOOTER //
// ./src/utility/tool.js